import React from 'react';
import { Link } from 'react-router-dom';
import '../App.css';

const PrivacyPage: React.FC = () => {
  return (
      <div className="container py-5 content-wrapper">
          <Link to="/" className="btn btn-outline-secondary mb-4">← Späť na hlavnú stránku</Link>
          <h1 className="mb-4">Zásady Ochrany Osobných Údajov</h1>
          <p className="text-muted">Aktualizované: 12.5.2025</p>
          <hr/>
          <p>Spoločnosť Growth Generals Limited - Kocúr.ai (ďalej len „Kocúr“, „my“ alebo „nás“) si váži a rešpektuje
              vaše súkromie. Tieto zásady ochrany osobných údajov sme pripravili s cieľom vysvetliť spôsob, akým
              zhromažďujeme, používame a zverejňujeme osobné údaje, keď využívate naše služby sledovania nákupného
              správania a cielenej reklamy, ktoré sú k dispozícii našim klientom (ďalej len „klienti“) prostredníctvom
              app.kocur.ai (ďalej len „aplikácia“), navštevujete našu webovú lokalitu umiestnenú na adrese
              https://kocur.ai/ (ďalej len „webová lokalita“), komunikujete s nami prostredníctvom sociálnych médií a
              inak s nami komunikujete. Aby sme mohli poskytovať služby, zhromažďujeme určité informácie od zákazníkov
              našich Klientov („Zákazníci“).</p>

          <p>Kocúr.ai zhromažďuje a používa osobné údaje predovšetkým v mene a v priebehu poskytovania služieb našim
              klientom. V určitých obmedzených súvislostiach môžeme zhromažďovať osobné údaje vo vlastnom mene,
              napríklad v súvislosti s návštevami našej webovej lokality a zasielaním marketingovej komunikácie.</p>

          <h3>Ako zhromažďujeme a používame osobné údaje v mene našich klientov</h3>

          <p>Poskytovanie služieb: Na účely poskytovania služieb prostredníctvom aplikácie Kocúr zhromažďujeme
              informácie o zákazníkoch našich klientov a ich zapojení do cielených reklamných služieb nasadených našimi
              klientmi. Okrem toho môžeme so súhlasom nášho Klienta a v jeho mene získavať informácie o Zákazníkoch
              Klienta od organizácií tretích strán. Od našich Klientov vyžadujeme, aby nám poskytli príslušné oznámenie
              a zabezpečili, že získali všetky potrebné oprávnenia alebo súhlas na poskytnutie alebo umožnenie
              zhromažďovania osobných údajov v ich mene v súlade s platnými zákonmi o ochrane osobných údajov. Okrem
              prípadov uvedených v tomto dokumente nezhromažďujeme ani nepoužívame osobné údaje našich Klientov na iné
              účely ako na poskytovanie služieb v mene našich Klientov. Aktívne nezhromažďujeme osobné údaje Klientov na
              účely predaja alebo marketingu spôsobom, ktorý by konkrétne identifikoval jednotlivca.</p>

          <p>Našim klientom poskytujeme služby týmito spôsobmi:</p>

          <p>Štatistiky: V mene našich Klientov zhromažďujeme údaje o interakcii ich zákazníkov s cielenou reklamou
              Klienta. Tieto informácie umožňujú našim Klientom pochopiť zapojenie do konkrétnych produktov. Tieto údaje
              môžeme používať a zdieľať v súhrnnej štatistickej forme na naše vlastné účely. </p>

          <p>Používanie aplikácie Kocúr: Môžeme monitorovať používanie aplikácie našimi Klientmi alebo inými oprávnenými
              používateľmi s cieľom odhaliť, vyšetriť alebo zabrániť akémukoľvek skutočnému alebo potenciálnemu
              porušeniu našich podmienok. Môžeme tiež vytvárať súhrnné údaje, ktoré nie sú určené na identifikáciu, a
              používať tieto informácie na zlepšenie aplikácie a monitorovanie výkonu, používania a stability
              aplikácie.</p>

          <p><b>Ako zhromažďujeme a používame osobné údaje prostredníctvom používania aplikácie Kocúr, webovej lokality
              a pri iných interakciách s vami</b></p>

          <p>Osobné údaje môžeme zhromažďovať, keď:</p>

          <p>
              <ul>
                  <li>navštívite webovú lokalitu</li>
                  <li>vytvoríte si účet</li>
                  <li>zakúpite plán</li>
                  <li>prihlásite sa na odber marketingových e-mailov, ako sú bulletiny, ponuky a propagačné akcie</li>
                  <li>zapojíte sa do projektu prostredníctvom sociálnych médií</li>
                  <li>zapojíte sa do súťaže alebo sa zúčastnite na propagačnej akcii</li>
                  <li>zúčastníte sa našich prieskumov</li>
                  <li>kontaktujete nás s komentárom, otázkou alebo sťažnosťou</li>
              </ul>
          </p>

          <p><b>Návšteva webovej stránky:</b> Na návštevu alebo používanie našej webovej lokality sa nemusíte
              registrovať. Pri návšteve našej webovej lokality však zhromažďujeme niektoré osobné údaje. Podrobné
              informácie o osobných údajoch, ktoré zhromažďujeme pri návšteve a používaní našej webovej lokality, a o
              možnostiach, ktoré máte v súvislosti s týmto zhromažďovaním, nájdete v časti „Informácie o našej webovej
              lokalite“ nižšie. </p>

          <p><b>Vytvorenie konta:</b> Ak si vytvoríte konto na používanie aplikácie, budete musieť poskytnúť osobné
              údaje vrátane, okrem iného, svojho mena a priezviska, titulu, e-mailovej adresy, profilovej fotografie,
              informácií o vašej organizácii a hesla, ktoré si vytvoríte. Tieto informácie používame na vytvorenie a
              správu vášho konta. Dôrazne odporúčame, aby ste svoje heslo nikomu neprezrádzali. Nikdy vás nebudeme
              žiadať o heslo v žiadnej nevyžiadanej komunikácii (napríklad v listoch, telefonátoch alebo e-mailových
              správach). Ak sa dozviete o akomkoľvek neoprávnenom prístupe k vášmu účtu alebo jeho používaní, ste
              povinní nás o tom okamžite informovať.</p>

          <p><b>Zakúpenie plánu:</b> Ak si zakúpite predplatné niektorého z našich plánov, my (alebo náš autorizovaný
              spracovateľ platieb tretej strany) budeme zhromažďovať informácie, ako je vaše meno a priezvisko,
              e-mailová adresa, telefónne číslo, poštová adresa, adresa na doručenie a vaše platobné informácie (vrátane
              fakturačnej adresy, čísla kreditnej karty, dátumu platnosti a kódu CVV/CVC), aby sme mohli spracovať vašu
              platbu.</p>

          <p><b>Marketingová komunikácia:</b> Ak sa prihlásite na odber e-mailovej marketingovej komunikácie, budeme
              zhromažďovať vašu e-mailovú adresu, aby sme vám mohli posielať bulletiny, ponuky, propagačné akcie a
              najnovšie aktualizácie, ktoré môžu byť prispôsobené vašim záujmom a preferenciám. Odber môžete kedykoľvek
              zrušiť kliknutím na odkaz „Odhlásiť sa z odberu“, ktorý je uvedený na konci každého e-mailu. Upozorňujeme,
              že od nás môžete naďalej dostávať oznámenia týkajúce sa transakcií alebo účtu.</p>

          <p><b>Súťaže a propagačné akcie:</b> Ak sa zúčastníte súťaže alebo propagačnej akcie, môžeme zhromažďovať vaše
              meno, adresu, e-mailovú adresu, telefónne číslo a akékoľvek ďalšie informácie alebo obsah potrebný na
              súťaž alebo propagačnú akciu vrátane doručenia ceny. Tieto informácie používame na správu vašej účasti v
              súťaži alebo propagačnej akcii.</p>

          <p><b>Prieskumy:</b> Z času na čas vám môžeme ponúknuť možnosť zúčastniť sa na niektorom z našich prieskumov.
              Tieto informácie používame na to, aby sme lepšie porozumeli našim používateľom a zlepšili našu webovú
              lokalitu.</p>

          <p><b>Stránky sociálnych médií:</b> Ak s nami komunikujete na našich stránkach sociálnych médií, zhromažďujeme
              informácie, ktoré zverejníte alebo nám pošlete, a používame ich na lepšie pochopenie našich zákazníkov a
              na to, aby sme vám mohli odpovedať. Pred zverejnením alebo poskytnutím akýchkoľvek osobných údajov na
              verejných stránkach by ste mali byť opatrní.</p>

          <p><b>Kontaktujte nás:</b> Keď nás kontaktujete prostredníctvom niektorého z našich kanálov (chat, telefón
              alebo e-mail) s komentárom, otázkou alebo sťažnosťou, môžete byť požiadaní o informácie, ktoré vás
              identifikujú, ako je vaše meno a e-mailová adresa, spolu s ďalšími informáciami, ktoré potrebujeme, aby
              sme mohli promptne odpovedať na vašu otázku alebo reagovať na váš komentár. Tieto informácie si môžeme
              ponechať, aby sme vám v budúcnosti pomohli a zlepšili naše služby zákazníkom a produkty.</p>

          <h3>2. Zdieľanie osobných údajov</h3>

          <p>Vaše osobné údaje nepredávame ani neposkytujeme tretím stranám bez vášho súhlasu, s výnimkou prípadov
              uvedených nižšie alebo prípadov, ktoré vyžaduje alebo povoľuje zákon.</p>

          <p><b>Poskytovatelia služieb:</b> Vaše osobné údaje budú odovzdané (alebo inak sprístupnené) určitým tretím
              stranám, ktoré poskytujú služby v našom mene. Poskytovateľov služieb využívame na poskytovanie služieb,
              ako je hosting webovej lokality, spracovanie platieb, poskytovanie služieb podpory, vykonávanie predaja,
              správa používateľských účtov, umožnenie poskytovania služieb, sprostredkovanie pracovných príležitostí a
              poskytovanie reklamných, analytických a marketingových služieb. Našim poskytovateľom služieb poskytujeme
              len informácie, ktoré potrebujú na vykonávanie určených funkcií, a nie sú oprávnení používať alebo
              zverejňovať osobné údaje na vlastné marketingové alebo iné účely. Naši poskytovatelia služieb sa môžu
              nachádzať v USA, Kanade alebo iných zahraničných jurisdikciách.</p>

          <p><b>Právne predpisy a ich dodržiavanie:</b> My a naši zahraniční poskytovatelia služieb môžeme poskytnúť
              vaše osobné údaje v reakcii na príkaz na prehliadku alebo iný právne platný dotaz alebo príkaz, alebo inej
              organizácii na účely vyšetrovania porušenia zmluvy alebo porušenia zákona alebo na účely odhaľovania,
              potláčania alebo predchádzania podvodom, alebo ak to môže byť inak požadované alebo povolené platným
              zákonom alebo právnym postupom, čo môže zahŕňať zákonný prístup zahraničných súdov, orgánov činných v
              trestnom konaní alebo iných štátnych orgánov. Vaše osobné údaje môžu byť tiež zverejnené, ak je to
              potrebné na stanovenie, uplatnenie alebo obhajobu právnych nárokov a na vyšetrovanie alebo predchádzanie
              skutočnej alebo predpokladanej strate alebo poškodeniu osôb alebo majetku. V prípade, že sa zverejnenie
              informácií o našich klientoch vyžaduje na základe platných právnych predpisov, bezodkladne informujeme
              nášho klienta pred splnením takýchto požiadaviek (v rozsahu, v akom nám to nie je zakázané) a plne
              spolupracujeme s pokynmi nášho klienta, pokiaľ ide o našu reakciu.</p>

          <p><b>Predaj podniku:</b> Akékoľvek informácie, ktoré o vás máme, môžeme previesť ako aktíva v súvislosti s
              navrhovanou alebo dokončenou fúziou, akvizíciou alebo predajom (vrátane prevodov uskutočnených v rámci
              konkurzného alebo konkurzného konania), ktoré sa týkajú celej spoločnosti a aplikácie alebo jej časti,
              alebo ako súčasť reorganizácie spoločnosti alebo inej zmeny v kontrole spoločnosti.</p>

          <h3>3. Informácie o našej webovej lokalite</h3>

          <p><b>Návšteva našej webovej lokality:</b> Vo všeobecnosti môžete navštíviť našu Webovú lokalitu bez toho, aby
              ste nám oznámili, kto ste, alebo poskytli akékoľvek osobné údaje. Zhromažďujeme však adresy IP
              (internetový protokol) všetkých návštevníkov našej webovej lokality a ďalšie súvisiace informácie, ako sú
              požiadavky na stránky, typ prehliadača, operačný systém a priemerný čas strávený na našej webovej
              lokalite. Tieto informácie používame na to, aby sme lepšie pochopili činnosť našej webovej lokality a aby
              sme mohli monitorovať a zlepšovať našu webovú lokalitu.</p>

          <p><b>Súbory cookie:</b> Naša webová lokalita používa technológiu nazývanú „cookies“. Súbor cookie je malý
              prvok údajov, ktorý naša webová lokalita odosiela do prehliadača používateľa a ktorý sa potom môže uložiť
              na pevný disk používateľa, aby sme mohli rozpoznať počítač alebo zariadenie používateľa, keď sa vráti.
              Svoj prehliadač môžete nastaviť tak, aby vás upozornil na prijatie súboru cookie alebo aby ste niektoré
              súbory cookie neprijímali. Ak sa však rozhodnete neprijímať súbory cookie z našej webovej lokality, možno
              nebudete môcť využívať všetky funkcie webovej lokality.</p>

          <p><b>Analýza:</b> V prípade, že používate webovú lokalitu, ktorá sa nachádza na webovej lokalite, je
              potrebné, aby ste sa oboznámili s jej obsahom: Môžeme využívať služby tretej strany, ako je napríklad
              Google Analytics, ktoré nám pomáhajú zhromažďovať a analyzovať informácie o navštívených oblastiach na
              Webovej lokalite (napríklad najčítanejšie stránky, strávený čas, vyhľadávané výrazy a iné údaje o
              zapojení) s cieľom vyhodnotiť a zlepšiť používateľské skúsenosti a Webovú lokalitu. Tieto tretie strany
              môžu používať súbory cookie a iné technológie sledovania. Ak chcete získať viac informácií o službe Google
              Analytics alebo zabrániť ukladaniu a spracovaniu týchto údajov (vrátane vašej IP adresy) spoločnosťou
              Google, môžete si stiahnuť a nainštalovať doplnok prehliadača, ktorý je k dispozícii na tomto
              odkaze:https://tools.google.com/dlpage/gaoptout?hl=en. Ďalšie informácie o ochrane osobných údajov a
              bezpečnosti služby Google Analytics môžete získať aj na nasledujúcich odkazoch:
              https://policies.google.com/technologies/partner-sites a
              https://support.google.com/analytics/topic/2919631 </p>

          <p><b>Odkazy tretích strán:</b> Naše webové stránky môžu obsahovať odkazy na iné webové stránky, ktoré
              spoločnosť Growth Generals nevlastní ani neprevádzkuje. Odkazy na webové lokality tretích strán
              poskytujeme pre pohodlie používateľa. Tieto odkazy nie sú určené ako podpora alebo odporúčanie na
              prepojené webové stránky. Prepojené webové stránky majú samostatné a nezávislé zásady ochrany osobných
              údajov, oznámenia a podmienky používania. Nad takýmito webovými lokalitami nemáme žiadnu kontrolu, a preto
              nenesieme žiadnu zodpovednosť za spôsob, akým organizácie, ktoré prevádzkujú takéto prepojené webové
              lokality, môžu zhromažďovať, používať alebo zverejňovať, zabezpečovať a inak zaobchádzať s osobnými
              údajmi. Odporúčame vám, aby ste si prečítali zásady ochrany osobných údajov každej webovej lokality, ktorú
              navštívite.</p>

          <h3>4. Reklama založená na záujmoch</h3>

          <p>Spolupracujeme s tretími stranami, ako sú reklamné siete a iné reklamné spoločnosti, ktoré na našej webovej
              lokalite používajú vlastné technológie sledovania (vrátane súborov cookie a pixelových značiek), aby vám
              mohli poskytovať prispôsobené reklamy na internete. Tieto spoločnosti môžu zhromažďovať informácie o vašej
              aktivite na našej Webovej lokalite a na webových lokalitách tretích strán (ako sú webové stránky, ktoré
              navštívite, a vaša interakcia s našou reklamou a inou komunikáciou) a používať tieto informácie na
              vytváranie predpovedí o vašich preferenciách, vytváranie personalizovaného obsahu a poskytovanie reklám,
              ktoré sú pre vás relevantnejšie na webových lokalitách tretích strán. Tieto informácie sa môžu použiť aj
              na vyhodnotenie účinnosti našich online reklamných kampaní. </p>

          <p>Upozorňujeme, že aj keď sa odhlásite z reklamy založenej na záujmoch od tretej strany, tieto technológie
              sledovania môžu naďalej zhromažďovať údaje na iné účely vrátane analytických a stále sa vám budú
              zobrazovať reklamy od nás, ale tieto reklamy nebudú cielené na základe informácií o vašom správaní, a
              preto môžu byť menej relevantné pre vás a vaše záujmy. </p>

          <p>Ak sa chcete úspešne odhlásiť, musíte mať vo svojom webovom prehliadači povolené súbory cookie (informácie
              o súboroch cookie a spôsobe ich povolenia nájdete v pokynoch svojho prehliadača). Vaše odhlásenie sa
              vzťahuje len na webový prehliadač, ktorý používate, takže sa musíte odhlásiť z každého webového
              prehliadača na každom počítači, ktorý používate. Ak po odhlásení vymažete uložené súbory cookie
              prehliadača, budete sa musieť znova odhlásiť.</p>

          <h3>5. Ochranné opatrenia a uchovávanie</h3>

          <p>Zaviedli sme primerané administratívne, technické a fyzické opatrenia v snahe zabezpečiť osobné údaje,
              ktoré máme v správe a pod kontrolou, pred krádežou, stratou a neoprávneným prístupom, použitím, úpravou a
              zverejnením. Prístup k osobným údajom obmedzujeme na základe zásady „need-to-know“ na zamestnancov a
              oprávnených poskytovateľov služieb, ktorí potrebujú prístup na plnenie svojich pracovných požiadaviek.</p>

          <p>Máme procesy uchovávania záznamov navrhnuté tak, aby sme osobné údaje neuchovávali dlhšie, ako je potrebné
              na účely stanovené v tomto dokumente alebo ako sa inak vyžaduje na splnenie právnych alebo obchodných
              požiadaviek. Niektoré údaje môžeme uchovávať, ak je to potrebné na predchádzanie podvodom alebo budúcemu
              zneužitiu, alebo na analýzu súhrnných údajov, ktoré neumožňujú identifikáciu osoby, na obnovu účtu, alebo
              ak to vyžaduje zákon. Všetky uchovávané osobné údaje budú naďalej podliehať podmienkam týchto zásad
              ochrany osobných údajov. </p>

          <h3>6. Vaše voľby</h3>

          <p>Ako je uvedené vyššie, ak ste sa prihlásili na odber našej e-mailovej komunikácie, môžete sa kedykoľvek
              odhlásiť kliknutím na odkaz „Odhlásiť sa“, ktorý je súčasťou spodnej časti e-mailu. Ak sa chcete odhlásiť
              z reklamy založenej na záujmoch, pozrite si časť „Reklama založená na záujmoch“ vyššie. Upozorňujeme, že
              od nás môžete naďalej dostávať oznámenia týkajúce sa transakcií alebo účtu. </p>

          <h3>7. Vaše práva</h3>

          <p>Ak dostaneme od jednotlivca žiadosť o prístup k osobným údajom, ktoré uchovávame v mene klienta, alebo o
              ich aktualizáciu, nasmerujeme ho na príslušného klienta. V rámci možností budeme našim Klientom pomáhať
              pri odpovedaní na individuálne žiadosti o prístup.</p>

          <p>V súlade s platnými právnymi predpismi môžete požiadať o prístup k osobným údajom v našej úschove alebo pod
              našou kontrolou alebo o ich opravu. Žiadosť môžete podať e-mailom alebo písomne na nižšie uvedené
              kontaktné údaje. Niektoré osobné údaje si môžeme vyžiadať na účely overenia totožnosti jednotlivca, ktorý
              žiada o prístup k svojim záznamom osobných údajov.</p>

          <h3>8. Aktualizácie zásad ochrany osobných údajov</h3>

          <p>Tieto zásady ochrany osobných údajov môžeme pravidelne aktualizovať, aby odrážali zmeny v našich postupoch
              ochrany osobných údajov. Odporúčame vám, aby ste si túto stránku pravidelne prezerali a uistili sa, že ste
              s týmito zmenami oboznámení. Akékoľvek nepodstatné zmeny (napríklad objasnenia) týchto zásad ochrany
              osobných údajov nadobudnú účinnosť v deň zverejnenia zmeny a akékoľvek podstatné zmeny nadobudnú účinnosť
              30 dní od ich zverejnenia na tejto webovej lokalite. V hornej časti týchto zásad ochrany osobných údajov
              uvedieme, kedy boli naposledy aktualizované.</p>

          <h3>9. Kontaktujte nás</h3>

          <p>Ak máte akékoľvek otázky alebo pripomienky týkajúce sa týchto zásad ochrany osobných údajov alebo spôsobu,
              akým my alebo naši poskytovatelia služieb zaobchádzame s vašimi osobnými údajmi, alebo ak chcete požiadať
              o prístup k zhromažďovaniu vašich osobných údajov, kontaktujte nás na adrese</p>

          <p>Chief Technology Officer - privacy@kocur.ai</p>
      </div>
  );
};

export default PrivacyPage;
